function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 376h283.35c6.186-14.112 20.28-24 36.65-24s30.465 9.888 36.65 24H480v32h-91.35c-6.186 14.112-20.28 24-36.65 24s-30.465-9.888-36.65-24H32m0-168h91.35c6.186-14.112 20.28-24 36.65-24s30.465 9.888 36.65 24H480v32H196.65c-6.186 14.112-20.28 24-36.65 24s-30.465-9.888-36.65-24H32m0-168h283.35c6.186-14.112 20.28-24 36.65-24s30.465 9.888 36.65 24H480v32h-91.35c-6.186 14.112-20.28 24-36.65 24s-30.465-9.888-36.65-24H32"
});

const SvgComponent = props => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _ref);

export default __webpack_public_path__ + "static/media/ios-options.9560018e.svg";
export { SvgComponent as ReactComponent };